import users from "./users";
import search from "./search";
import movies from "./movies";
import posts from "./posts";

const api = { users, search, movies, posts };

export default api;